export const maxThumbsNbr = 24; //12; //the max number of thumbnail per search page
export const maxFilesNumber = 50; //the max number of file (image of video we can attach to a single story
